import { createContext, useContext } from "react";

const CompanionModalContainerContext = createContext(null);

export const CompanionModalContainerProvider =
  CompanionModalContainerContext.Provider;

export const useCompanionModalContainer = () =>
  useContext(CompanionModalContainerContext);
